import { cva, VariantProps } from 'class-variance-authority';
import { ButtonHTMLAttributes } from 'react';
import { cn } from '../../lib/utils';

const buttonVariants = cva(
  'inline-flex min-h-11 cursor-pointer items-center justify-center gap-2 rounded-md px-5 text-sm font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-link-blue/30 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      variant: {
        default:
          'border border-wren-green bg-wren-green text-white hover:bg-success-green',
        outline:
          'border border-gray-7 bg-white text-wren-green hover:border-wren-green hover:bg-wren-green-low',
        ghost:
          'border border-transparent bg-transparent text-link-blue hover:bg-bg-gray',
        destructive:
          'border border-error-red bg-error-red text-white hover:opacity-90',
        'destructive-outline':
          'border border-error-red bg-white text-error-red hover:bg-error-red/10',
      },
      size: {
        default: 'px-5 py-2.5',
        sm: 'min-h-9 px-3 py-1.5 text-xs',
        lg: 'min-h-12 px-6 py-3 text-base',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> &
  VariantProps<typeof buttonVariants>;

function Button({
  className,
  variant,
  size,
  type = 'button',
  ...props
}: ButtonProps) {
  return (
    <button
      data-slot="button"
      type={type}
      className={cn(buttonVariants({ variant, size }), className)}
      {...props}
    />
  );
}

export { Button, buttonVariants };
